import { ICellRendererParams } from 'ag-grid-community';
import React, { FC } from 'react';
import { LastFiveUpdates } from 'components/organisms/projects/project-list/columns/last-five-updates';

export const Last5StatusUpdatesCellRenderer: FC<ICellRendererParams> = ({
  value,
  data,
}) => {
  return (
    <LastFiveUpdates
      data={value}
      projectId={data.projectId}
      subTitle={data.projectName}
    />
  );
};
